module.exports = __webpack_public_path__ + "public/Icons/bin.svg?650cdc57";